export enum FooterLinkTypes {
	PRIVACY_POLICY = 'privacyPolicy',
	TERMS_AND_CONDITONS = 'termsAndConditions',
}
